import React from 'react';
import { useLocation } from 'react-router-dom';

import BarraAlta from './BarraAlta';
import MiddleMenu from './components/middle-menu/MiddleMenu';
import './styles/Header.css';
import './styles/Global.css';
import './styles/RigaGiochi.css';
import { giochiAccesi } from '../../utils/giochi';
import { useSkin } from '../../moduli/useSkin';

/**
 * L'INTESTAZIONE: due righe e basta.
 *
 * Sopra la striscia (BarraAlta) con tutto quello che riguarda il conto;
 * sotto la riga dei giochi, che era gia' cosi' e resta com'e'.
 *
 * Prima qui c'erano due intestazioni complete scritte nello stesso file, un
 * ramo per misura di schermo, e il ramo del telefono non montava il blocco
 * del conto: da telefono non c'era modo di uscire, ne' di vedere il saldo
 * intero. Adesso e' una sola, e a capo ci va da sola.
 *
 * Sono sparite due cose, e vale la pena dire perche':
 *  - la ricerca evento: il campo non era collegato a niente, nessun onChange
 *    e nessuna ricerca. Una casella che non cerca e' peggio del niente,
 *    perche' fa credere che la ricerca esista.
 *  - Promozioni: non c'e' nessuna pagina dietro, era una scritta.
 * Tornano tutte e due quando ci sara' qualcosa da collegarci.
 */

function Header({ userService, host }) {
  const location = useLocation();
  const path = location?.pathname || '/';
  const imgUrl = typeof host === 'undefined' ? '' : host;
  /* La riga dei giochi mostra solo le sezioni accese sulla skin, e si
     ridisegna quando la skin cambia (in anteprima, a ogni ritocco). */
  useSkin();
  const giochi = giochiAccesi();

  return (
      <div className="header-container">
        <BarraAlta userService={userService} />

        <div className="riga-giochi">
          <MiddleMenu host={host} menu={giochi} imgUrl={imgUrl} path={path} />
        </div>
      </div>
  );
}

export default Header;
